import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import './styles.scss';
import { useSelector } from 'react-redux';
import ProductItem from './ProductItem';
import GradientText from 'components/GradientText';
import WithSidebarLayout from 'Layout/WithSidebar';
// products_tag
// products_title
// logo
// preview_button_text
// preview_description
// preview_image
// preview_title
// slug
// type
const Products = () => {
    const { products = [], products_tag, products_title } = useSelector(state => state?.homepage?.data?.data) || {};

    return (
        <section className="container our-products">
            <div className="inner-container type-3">
                <div className="main-text-container">
                    <LabelButton>{products_tag}</LabelButton>
                    <div className="offset-left-4">
                        <GradientText size="middle">
                            <span dangerouslySetInnerHTML={{ __html: products_title }} />
                        </GradientText>
                    </div>
                </div>
            </div>
            <WithSidebarLayout containerType="type-2" Sidebar={<></>} breakpoint="lg">
                <div className="homepage-product-items">
                    {products.map((product, index) => (
                        <ProductItem index={index} key={product.slug} data={product} />
                    ))}
                </div>
            </WithSidebarLayout>
        </section>
    );
};

export default Products;
